import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { api } from "../lib/api";

export const ListasBanner = () => {
  const [alertas, setAlertas] = useState([]);
  useEffect(() => {
    api.get("/listas/estado").then((r) => setAlertas(r.data.alertas)).catch(() => setAlertas([]));
  }, []);
  if (!alertas.length) return null;
  return (
    <div className="bg-rose-50 border-b border-rose-200 text-rose-800 px-4 py-2 text-sm" data-testid="listas-banner">
      <p className="flex items-center gap-2 font-semibold"><AlertTriangle size={16} /> Aviso sobre las listas ONU, OFAC y PEP</p>
      <ul className="list-disc ml-6">{alertas.map((a) => <li key={a}>{a}</li>)}</ul>
    </div>
  );
};
